export { default } from './horizontal-scroll';
